export default {
    SET_MESSAGE(state, payload) {
        if (payload) {
            state.message = Object.assign(
                {},
                {
                    type: payload.type || 'info',
                    message: payload.message || '',
                    showClose: payload.showClose || true,
                    center: payload.center || false,
                    isShowMessage: payload.isShowMessage
                }
            );
        }
    },

    SET_CONFIRM(state, payload) {
        if (payload) {
            state.confirm = Object.assign(
                {},
                {
                    type: payload.type || 'info',
                    message: payload.message,
                    callback: payload.callback,
                    isShowConfirm: payload.isShowConfirm
                }
            );
        }
    }
};
